import React from 'react';
import { Input, Select } from 'formik-antd';
import { Divider, Typography } from 'antd';
import FormControl from '~/components/Form/FormControl';
import Box from '~/components/Box';
import Row from '~/components/Row';

export default function DesignerTab({ t, values, errors, touched, countries }) {
  const { Option } = Select;
  const { Text } = Typography;
  return (
    <Box>
      <Row>
        <FormControl
          cols={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
          field="designer.companyName"
          error={(touched.designer?.companyName && errors.designer?.companyName) || errors.designer?.companyName}
          label={t('screens:bids.data.designerCompanyName')}
        >
          <Input name="designer.companyName" autoComplete="off" />
        </FormControl>
      </Row>
      <Row>
        <FormControl
          cols={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
          field="designer.representativeName"
          error={
            (touched.designer?.representativeName && errors.designer?.representativeName) ||
            errors.designer?.representativeName
          }
          label={t('screens:bids.data.designerRepresentativeName')}
        >
          <Input name="designer.representativeName" autoComplete="off" maxLength={27} />
        </FormControl>
        <FormControl
          cols={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
          field="designer.representativePhone"
          error={
            (touched.designer?.representativePhone && errors.designer?.representativePhone) ||
            errors.designer?.representativePhone
          }
          label={t('screens:bids.data.designerRepresentativePhone')}
        >
          <Input name="designer.representativePhone" autoComplete="off" maxLength={27} />
        </FormControl>
      </Row>
      <Divider orientation="left" orientationMargin="0">
        <Text>{t('screens:bids.data.address')}</Text>
      </Divider>
      <Row>
        <FormControl
          cols={{ xs: 24 }}
          error={touched.designer?.address?.addressLineOne && errors.designer?.address?.addressLineOne}
          field="designer.address.addressLineOne"
          label={t('screens:addresses.data.addressLineOne')}
        >
          <Input name="designer.address.addressLineOne" autoComplete="off" maxLength={40} />
        </FormControl>
        <FormControl
          cols={{ xs: 24 }}
          error={touched.designer?.address?.addressLineTwo && errors.designer?.address?.addressLineTwo}
          field="designer.address.addressLineTwo"
          label={t('screens:addresses.data.addressLineTwo')}
        >
          <Input name="designer.address.addressLineTwo" autoComplete="off" maxLength={40} />
        </FormControl>
        <FormControl
          cols={{ xs: 12 }}
          error={touched.designer?.address?.city && errors.designer?.address?.city}
          field="designer.address.city"
          label={t('screens:addresses.data.city')}
        >
          <Input name="designer.address.city" autoComplete="off" maxLength={16} />
        </FormControl>
        <FormControl
          cols={{ xs: 12 }}
          error={touched.designer?.address?.state && errors.designer?.address?.state}
          field="designer.address.state"
          label={t('screens:addresses.data.state')}
        >
          <Input name="designer.address.state" autoComplete="off" maxLength={21} />
        </FormControl>
        <FormControl
          cols={{ xs: 12 }}
          field="designer.address.zipCode"
          label={t('screens:addresses.data.zipCode')}
          error={touched.designer?.address?.zipCode && errors.designer?.address?.zipCode}
        >
          <Input name="designer.address.zipCode" autoComplete="off" maxLength={13} />
        </FormControl>
        <FormControl
          cols={{ xs: 12 }}
          error={touched.designer?.address?.country && errors.designer?.address?.country}
          field="designer.address.country"
          label={t('screens:addresses.data.country')}
        >
          <Select name="designer.address.country" placeholder="Select">
            {countries.map(item => {
              return (
                <Option key={item.name} value={item.name}>
                  {item.description}
                </Option>
              );
            })}
          </Select>
        </FormControl>
        <FormControl
          cols={{ xs: 24, sm: 24, md: 24, lg: 24, xl: 24 }}
          field="designer.address.note"
          error={(touched.note && errors.note) || errors.note}
          label={t('screens:addresses.data.note')}
        >
          <Input name="designer.address.note" autoComplete="off" maxLength={41} />
        </FormControl>
      </Row>
    </Box>
  );
}
